import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface BangTinhKhauHaoTSCDTTResponse<T = any> {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
  total?: T | null;
  totals?: T | null;
}

export interface FetchAllBangTinhKhauHaoTSCDTTReturn {
  rows: any[];
  totalRow: any | null;
}

export const fetchAllBangTinhKhauHaoTSCDTT = async (
  entitySlug: string,
  body: Record<string, any> = {},
  pageSize = 200
): Promise<FetchAllBangTinhKhauHaoTSCDTTReturn> => {
  let page = 1;
  let all: any[] = [];
  let totalRow: any | null = null;

  while (true) {
    const response = await api.post<BangTinhKhauHaoTSCDTTResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.BANG_TINH_KHAU_HAO_TSCD_THEO_THANG}/`,
      body,
      {
        params: {
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    all = all.concat(pageResults);

    // Get totalRow from first page response
    if (page === 1) {
      totalRow = (response.data as any).total || (response.data as any).totals || null;
    }

    if (!response.data.next) {
      break;
    }

    page += 1;
  }

  return {
    rows: all,
    totalRow
  };
};
